import { IMultistepStepProps } from "./types";
import { useMultistep } from "./context";
import { Button } from "@mui/material";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

export function MultistepStep({ disabled, body }: IMultistepStepProps) {
  const { handleNextStep, handlePrevStep, handleSave, isFirstStep, isLastStep } =
    useMultistep();

  return (
    <>
      <div>{body}</div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: "8px",
          marginTop: "50px",
        }}
      >
        <Button
          variant="outlined"
          style={{
            paddingTop: "0.25rem",
            paddingBottom: "0.25rem",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            borderRadius: "0.375rem",
            height: "2.5rem",
            fontSize: "0.875rem",
            lineHeight: "1.25rem",
            fontWeight: 600,
            width: "130px",
          }}
          disabled={isFirstStep}
          startIcon={<ChevronLeftIcon color="primary" style={{ height: "22px", marginLeft: "-8px"}} />}
          onClick={handlePrevStep}
        >
          Voltar
        </Button>
        <Button
          variant="outlined"
          style={{
            paddingTop: "0.25rem",
            paddingBottom: "0.25rem",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            borderRadius: "0.375rem",
            height: "2.5rem",
            fontSize: "0.875rem",
            lineHeight: "1.25rem",
            fontWeight: 600,
            width: "130px",
          }}
          disabled={disabled || isLastStep}
          onClick={handleNextStep}
        >
          {"Próximo"}
        </Button>
        <Button
          variant="contained"
          style={{
            paddingTop: "0.25rem",
            paddingBottom: "0.25rem",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            borderRadius: "0.375rem",
            height: "2.5rem",
            fontSize: "0.875rem",
            lineHeight: "1.25rem",
            fontWeight: 600,
            width: "130px",
            marginLeft: "50px"
          }}
          onClick={handleSave}
        >
          {"Salvar"}
        </Button>
        {/* <Button
          variant="contained"
          style={{
            paddingTop: "0.25rem",
            paddingBottom: "0.25rem",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            borderRadius: "0.375rem",
            height: "2.5rem",
            fontSize: "0.875rem",
            lineHeight: "1.25rem",
            fontWeight: 600,
            width: "130px",
          }}
          disabled={disabled}
          onClick={handleNextStep}
        >
          {isLastStep ? "Salvar" : "Próximo"}
        </Button> */}
      </div>
    </>
  );
}
